<template>
    <div class="struk-pembayaran">
        <b-row class="pl-2 mr-1 btn-struk">
            <b-col cols="6" class="mb-2">
                <button type="button" class="btn btn-sm btn-success ml-3" :disabled="struckType == 'A4'"
                    @click="changeStruk('A4')">
                    Struk A4
                </button>
                <button type="button" class="btn btn-sm btn-success ml-3" :disabled="struckType == 'Edc'"
                    @click="changeStruk('Edc')">
                    Struk EDC
                </button>
                <button type="button" class="btn btn-sm btn-primary ml-2 mt-1" @click="cetakStruk"
                    v-show="struckType == 'A4'">
                    Print Struk
                </button>
                <b-dropdown id="dropdown-1" text="Print Struk" variant="primary" size="sm" class="mt-1 ml-2"
                    v-show="struckType == 'Edc'">
                    <b-dropdown-item @click="cetakStruk(58)">EDC 58mm</b-dropdown-item>
                    <b-dropdown-item @click="cetakStruk(80)">EDC 80mm</b-dropdown-item>
                </b-dropdown>
                <button type="button" class="btn btn-sm btn-primary ml-3" @click="emailStruk"
                    v-if="dataStruk.status == 'LUNAS'">
                    Email Struk
                </button>
            </b-col>
            <b-col cols="6" class="mb-2 text-right">
                <button type="button" class="btn btn-sm btn-danger" @click="handleRedirect">
                    Tutup
                </button>
            </b-col>
        </b-row>

        <div class="container-fluid" id="printStruk">
            <div v-if="dataStruk != null">
                <StrukA4 v-show="struckType == 'A4'" :klinik='klinik' :details='details' :dataStruk='dataStruk'
                    :isDpm="isDpm" />
                <StrukEdc v-show="struckType == 'Edc'" :klinik='klinik' :details='details_edc' :dataStruk='dataStruk'
                    :isDpm="isDpm" />
            </div>
        </div>

        <b-modal id="modalEmailPasien" title="Masukkan Email Untuk Mengirimkan Struk" ok-only no-close-on-backdrop>
            <div role="group">
                <label for="emailPasien">Email <span class="text-danger">*</span></label>
                <b-form-input id="emailPasien" aria-describedby="emailPasien-help emailPasien-feedback"
                    :state="emailPasien.length == 0 ? null : !emailError" v-model="emailPasien"></b-form-input>

                <b-form-invalid-feedback id="emailPasien-feedback" v-if="emailError != ''">
                    {{ emailError }}
                </b-form-invalid-feedback>
            </div>

            <template v-slot:modal-footer>
                <div class="w-100">
                    <b-button variant="primary" size="sm" class="float-right ml-2" @click="sendEmail"
                        :disabled="emailError != ''">
                        Kirim Email
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import startCase from "lodash/startCase"
import { mapGetters } from "vuex"
import moment from "moment"
import StrukA4 from "./StrukA4.vue"
import StrukEdc from "./StrukEdc.vue"
import html2canvas from 'html2canvas';

export default {
    data() {
        return {
            pembayaran_id: null,
            emailPasien: '',
            emailValidation: {
                required: false,
                format: false,
            },
            details: [],
            details_edc: [],
            detailsEdc: [],
            klinik: {},
            dataStruk: [],
            struckType: "A4",
        }
    },
    components: {
        StrukA4,
        StrukEdc
    },
    watch: {
        emailPasien(newVal) {
            this.emailValidation.required = (newVal !== '')
            this.emailValidation.format = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(newVal)
        }
    },
    computed: {
        ...mapGetters({
            strukVal: "struk/struk_values",
            isDpm: "getFaskesType"
        }),
        emailError() {
            if (this.emailValidation.required == false) {
                return "Email Harus Diisi"
            }
            else if (this.emailValidation.format == false) {
                return "Format Email Tidak Sesuai"
            }
            else {
                return ''
            }
        },
        now() {
            return moment().format("DD MMM YYYY, HH:mm:ss")
        }
    },
    mounted() {
        this.pembayaran_id = this.$router.currentRoute.params.id
        this.fetchStruk()
    },
    methods: {
        async fetchStruk() {

            const isRoute = this.$router.currentRoute.params.id
            const res = await this.$axios.get(`penjualan/detail/${isRoute}`)
            const { success, data } = res.data

            if (!success) {
                this.$swal({
                    type: 'error',
                    title: startCase("gagal"),
                    text: startCase("Penjualan Tidak Ditemukan")
                }).then(res => {
                    this.$router.push({
                        name: "klinik-penjualan-list"
                    })
                })
                return;
            }

            if (success) {
                let total = 0;
                if (data.kategori == 'BPJS') {
                    data.detail.forEach((d) => {
                        if (d.from_bpjs == 0) {
                            total += +d.subtotal_tarif_net;
                        }
                    });
                } else {
                    data.detail.forEach((d) => {
                        total += +d.subtotal_tarif_net;
                    });
                }
                this.dataStruk = data
                this.details = [...data.detail]
                this.details_edc = [...data.detail]
                this.klinik = data.klinik
                this.details.push(
                    { jenis_potongan: data.jenis_potongan, potongan: 'Total', subtotal_tarif_net: total },
                    { jenis_potongan: data.jenis_potongan, potongan: 'Diskon', subtotal_tarif_net: +data.potongan },
                    { jenis_potongan: data.jenis_potongan, potongan: 'Total Nett', subtotal_tarif_net: +data.total_net }
                )
            }

        },
        close() {
            this.$router.push({
                name: "klinik-penjualan-list"
            })
        },
        changeStruk(type) {
            this.struckType = type;
        },
        cetakStruk(size = 58) {
            let el = document.getElementsByClassName('app-wrapper')
            el[0].classList.remove('sidebar-open-mobile')
            if (this.struckType == 'Edc') {
                this.edcGenerate(size);
            } else {
                document.getElementById('wdgt_chat_icon_knk').style.display = 'none'
                setTimeout(() => {
                    document.getElementById('wdgt_chat_icon_knk').style.display = 'flex'
                }, 1000)
                window.print()
            }
        },
        showPembayaran() {
            this.$router.push({
                name: "klinik-penjualan-tambah-save",
                params: {
                    id: this.$router.currentRoute.params.id
                }
            });
        },
        handleRedirect() {
            if (this.dataStruk.status === 'LUNAS') {
                this.close();
            } else {
                this.showPembayaran();
            }
        },
        edcGenerate(size) {
            console.log("HEHEHE")
            // Get HTML to print from element
            document.querySelector("#print").classList.remove("d-none");
            const prtHtml = document.getElementById('print');
            const prtHtmlEL = document.getElementById('print').innerHTML;
            // Open the print window
            const screenWidth = screen.width;
            const screenHeight = screen.height;

            const left = (screenWidth - 800) / 2;
            const top = (screenHeight - 900) / 2;

            const WinPrint = window.open('', '', `left=${left},top=${top},width=800,height=900,menubar=0,toolbar=0,scrollbars=0,status=0`);

            html2canvas(prtHtml, {
                scale: 2,
                useCORS: true,
                allowTaint: false,
                checkCrossOrigin: false,
            }).then(function (canvas) {
                let html = `<!DOCTYPE html>
                    <html>
                        <head>
                        <style type="text/css">
                            body {
                            width: 155px;
                            max-width: 155px;
                            margin-left: 3px;
                            }
                        </style>
                        </head>
                        <body>
                        <img src="${canvas.toDataURL('image/png')}" style="margin: auto; width: ${size}mm !important;">
                        </body>
                    </html>`

                WinPrint.document.write(html);
            });

            window.setTimeout(() => {
                WinPrint.focus();
                WinPrint.print();
            }, 1000)

            document.querySelector("#print").classList.add("d-none");

        },
        //
        emailStruk() {
            // this.emailPasien = this.dataStruk.email
            this.$bvModal.show('modalEmailPasien')
        },
        sendEmail() {
            let isRoute = this.$router.currentRoute.params.id
            let selectedKlinikId = this.klinik.id;
            this.$axios.post(`penjualan/send-invoice-email/${isRoute}`, {
                email: this.emailPasien,
                selectedKlinikId: selectedKlinikId,
                type: this.struckType == 'Edc' ? 'edc' : 'A4',
                isDpm: this.isDpm
            }).then(res => {
                this.$swal({
                    title: `Struk berhasil dikirimkan ke alamat email '${this.emailPasien}'`,
                    type: "success",
                    confirmButtonText: startCase("ok")
                })

                this.$bvModal.hide('modalEmailPasien')
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.pembayaran-status {
    position: absolute;
    top: 62%;
    left: 30%;
}

.struk-pembayaran {
    zoom: 90%;
}

.btn.disabled,
.btn:disabled {
    opacity: 1 !important;
    color: #fff;
    background-color: #067c22;
    border-color: #067c22;
}

img {
    height: 100px;
    border-radius: 10px;
}
</style>